{
  "hero": {
    "title": "Dienste",
    "cta": "Kontakt aufnehmen"
  },
  "banner": {
    "message": "Ich bin für alle Fragen da",
    "cta": "Kontakt aufnehmen"
  },
  "services": [
    {
      "number": "01",
      "title": "Video- und Fotografie-Content-Produktion",
      "description": "Das fehlende Glied im modernen Geschäft. Ich produziere hochwertige Videos und Fotografie, die die meisten Agenturen erwarten, dass Sie selbst bereitstellen. Ich gestalte Ihre Website um den Content, den ich drehe.",
      "items": [
        {
          "title": "Markengeschichten",
          "description": "Kinematische Videos, die Ihr Unternehmen vermenschlichen.",
          "previewVideo": "povesti-brand"
        },
        {
          "title": "Produktdemo und Erklärvideos",
          "description": "Komplexe Technologie einfach verständlich machen.",
          "previewVideo": "demo-produs"
        },
        {
          "title": "Social-first Vertikalvideo",
          "description": "Hochformat-Reels, Stories und TikTok-Schnitte aus einem Dreh.",
          "previewVideo": "social-first"
        },
        {
          "title": "Produkt- und Lifestyle-Fotografie",
          "description": "Professionelle Stills für Websites, Kataloge, E-Commerce und Kampagnen.",
          "previewVideo": "fotografie-produs"
        },
        {
          "title": "Vor-Ort- und Event-Produktion",
          "description": "Dreharbeiten in Ihrem Büro, Laden, Weingut oder bei Live-Events.",
          "previewVideo": "filmari-on-location"
        },
        {
          "title": "Asset-Bibliotheken",
          "description": "Eine monatliche Sammlung professioneller Fotos und Kurzvideos für aktive Kanäle."
        }
      ]
    },
    {
      "number": "02",
      "title": "Brand Engineering",
      "description": "Vom ersten Entwurf bis zum finalen Deployment. Ich glaube nicht an \"getrenntes\" Branding. Ich baue Ihre visuelle Identität und Ihren digitalen Storefront als einen einzigen, lebendigen Organismus.",
      "items": [
        {
          "title": "Identitätsdesign",
          "description": "Logos, Typografie und Brand Books, die sich ins Web übertragen lassen."
        },
        {
          "title": "Hochleistungs-Web-Entwicklung",
          "description": "Maßgeschneiderte Websites, die für Conversion und Geschwindigkeit gebaut sind."
        },
        {
          "title": "Content-getriebene Websites",
          "description": "Websites, die um die Fotos und Videos aufgebaut sind, die wir gemeinsam produzieren."
        },
        {
          "title": "Landingpages und Kampagnen-Microsites",
          "description": "Fokussierte Seiten für Launches, Ads, Partnerschaften und Lead-Generierung."
        },
        {
          "title": "Digitale Ökosysteme",
          "description": "Sicherstellen, dass Ihre Marke auf einem Smartphone genauso wirkt wie auf einem Desktop."
        },
        {
          "title": "Visuelle Content-Updates",
          "description": "Aktualisierung Ihrer Website mit neuen Produktfotos, Videos und saisonalen Kampagnen."
        }
      ]
    }
  ]
}
